import { render } from "./MainDoctor.vue?vue&type=template&id=9f87b762"
import script from "./MainDoctor.vue?vue&type=script&lang=js"
export * from "./MainDoctor.vue?vue&type=script&lang=js"

import "./MainDoctor.vue?vue&type=style&index=0&id=9f87b762&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__